import React from 'react'
import { Transition } from 'react-transition-group'
import { Button } from 'core/components/button'
import { classNames } from 'core/helpers/misc'
import { ModalPortal } from './ModalPortal'

const closeModal = (action, setModal) =>
  setModal(prev => {
    const { opened, onAct } = prev

    if (opened && onAct) {
      onAct(action === 'submit')
    }

    return {
      title: '',
      message: '',
      opened: false,
    }
  })

export const ModalConfirm = React.memo(({ modal, setModal }) => {
  const { title, message, opened } = modal
  const show = opened

  return (
    <ModalPortal>
      <Transition in={show} timeout={300}>
        {status => (
          <>
            <div
              aria-modal="true"
              className={classNames('modal fade', {
                show: status === 'entered',
              })}
              role="dialog"
              style={{
                display: status === 'exited' ? 'none' : 'block',
                zIndex: 1060,
              }}
              tabIndex={-1}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{title}</h5>

                    <Button
                      aria-label="close"
                      className="close"
                      data-dismiss="modal"
                      onClick={() => closeModal('close', setModal)}
                      type="button"
                    />
                  </div>
                  <div className="modal-body">
                    <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
                  </div>
                  <div className="modal-footer">
                    <Button
                      customClassName="btn-primary"
                      icon="fas fa-check"
                      onClick={() => closeModal('submit', setModal)}
                      title="Confirmar"
                    />

                    <Button
                      customClassName="btn-danger"
                      icon="fas fa-times"
                      onClick={() => closeModal('cancel', setModal)}
                      title="Cancelar"
                    />
                  </div>
                </div>
              </div>
            </div>

            {status !== 'exited' && (
              <div
                className={classNames('modal-backdrop fade', {
                  show: status === 'entered',
                })}
                style={{
                  zIndex: 1059,
                }}
              />
            )}
          </>
        )}
      </Transition>
    </ModalPortal>
  )
})
